import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 8a.667.667 0 0 0-.667.667v4a.667.667 0 0 1-.666.667H3.333a.667.667 0 0 1-.666-.667V3.333a.667.667 0 0 1 .666-.666h4a.667.667 0 0 0 0-1.334h-4a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2v-4A.667.667 0 0 0 14 8M4 8.507v2.827a.667.667 0 0 0 .667.666h2.826a.67.67 0 0 0 .474-.193l4.613-4.62 1.893-1.854a.67.67 0 0 0 0-.946l-2.826-2.86a.667.667 0 0 0-.947 0L8.82 3.413l-4.627 4.62A.67.67 0 0 0 4 8.507m7.173-5.567 1.887 1.887-.947.946-1.886-1.886zm-5.84 5.84 3.954-3.953 1.886 1.886-3.953 3.954H5.333z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })